import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import enUS from 'date-fns/locale/en-US';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar2DayFill, Calendar2MonthFill, Calendar2WeekFill } from 'react-bootstrap-icons';
import { TwitterPicker } from 'react-color';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import GenericIconPicker, { ICONS } from '../../../../components/icons/GenericIconPicker';
import Authentication from '../../../../libs/api/services/Authentication';
import Calendars from '../../../../libs/api/services/Calendars';
import { ClaimsFilter } from '../../../../libs/authentication/ClaimsFilter';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
import PatientContext from '../../patient/management/PatientProvider';
import WorkFlowDetailsModal from '../../workflow/management/WorkFlowDetailsModal';
import FacilitySearchComponent from '../components/common/FacilitySearchComponent';

// Should have a section on the top to sselect Year, Month, Week, Day, View
// The view selection has 3 options:
// 1. Month View
// 2. Week View
// 3. Day View
// The view selection should be buttons that toggle the view
// Under this section there should be a select for different calendars linked to the user
// Under this section should be a calendar grid that displays the selected view
// When selecting a date or time slot it should open a modal to create an event
// There should be the ablity to drag and drop events to reschedule them 
// There should be the ability to drag and drop time solts to be used for start and end date/time

// The modal should have a form to fill in the event details
// It should have a header showing the selected date and time in format yyyy/mm/dd hh:mm
// It should be split into two sections (Left / Right)
// The left section should have the following fields:
// 1. Event Title
// 2. Event Description
// 3. Start Date/Time
// 4. End Date/Time
// 5. Location
// 6. Clinician
// 7. Patient
// 8. Details (Notes or additional information)
// The right section should have a list of templates that can be selected
// The templates should be selectable and when selected it should fill in the left section with the template

// The modal should have a save button that saves the event to the calendar
// It should also have a cancel button that closes the modal without saving

// The modal should also have the ability to select a calendar to synchronize with
// The modal should have a the ability to link the event to a patient / clinician if applicable
// The modal should have the ability to select an icon and color for the event
// The modal should have a section where the user can add additional notes or information about the event (not related to the details filled in for the event)

const DnDCalendar = withDragAndDrop(Calendar);

const locales = {
    'en-US': enUS,
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});

const eventPropGetter = (event, start, end, isSelected) => {
    const style = {
        backgroundColor: event.color.value,
        borderRadius: '5px',
        opacity: 0.8,
        color: 'white',
        border: '0px',
        display: 'block'
    };
    return {
        style
    };
};

const EventComponent = ({ event }) => (
    <div>
        {event.icon && event.icon.value && event.icon.value !== '' &&
            ICONS.find(icon => icon.name === event.icon.value).icon
        }
        <span>{event.title}</span>
    </div>
);

export default function CalendarCanvas({ calendarType }) {
    const [calendars, setCalendars] = useState([]);
    const [calendar, setCalendar] = useState([]);
    const [events, setEvents] = useState([]);
    const [view, setView] = useState('week');
    const [date, setDate] = useState(new Date());
    const [modal, setModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [editingEvent, setEditingEvent] = useState(null);
    const [showPreModal, setShowPreModal] = useState(false);
    const [preModalMode, setPreModalMode] = useState('add');
    const [draggedEvent, setDraggedEvent] = useState(null);
    const [draggedSlot, setDraggedSlot] = useState(null);
    const [errorModal, setErrorModal] = useState({ show: false, message: '' });

    const { setSectionInfo } = useContext(CommonFunctionsContext)
    const { activePatient } = useContext(PatientContext)

    const { id } = useParams() // Patient ID in the url to show that managing a patient

    // Load users calendars
    /*
    [
  {
    "id": "8ba30f22-1126-48ed-d7df-08dd0ac4a445",
    "name": "Clinton Moss DrData Calendar",
    "provider": "DrData",
    "calendarUser": {
      "id": 5,
      "title": "",
      "firstName": "Clinton",
      "lastName": "Moss Oswald",
      "idNumber": "9002015056085",
      "username": "",
      "emailAddress": "clinton@rootbranch.co.za",
      "mobileNumber": "0825779793",
      "userRoles": [],
      "userFacilitieRoles": [
        {
          "id": 4,
          "facility": {
            "id": 0,
            "facility": ""
          },
          "roles": {
            "id": 1,
            "role": "Patient",
            "preferedName": "Patient",
            "isAvailable": true
          }
        }
      ]
    },
    "externalCalendars": []
  }
]
  */
    useEffect(() => {
        if (activePatient)
            setSectionInfo(`Calendar events for ${activePatient.userProfile.firstName} ${activePatient.userProfile.lastName} at ${Authentication.getFacilityName()}`);
        else
            setSectionInfo(`Calendar events at ${Authentication.getFacilityName()}`);
    }, [activePatient])
    React.useEffect(() => {
        const loadCalendars = async () => {
            const userCalendars = await Calendars.ListAvaialbeCelendars();
            console.log("User Calendars: ", userCalendars);
            setCalendars(userCalendars);
            if (userCalendars.length === 1) setCalendar(userCalendars[0]);
            // console.log("User Calendars: ", userCalendars);
            // if (userCalendars.length > 0) {
            //     const defaultCalendar = userCalendars.find(c => c.calendarType.type === calendarType) || userCalendars[0];
            //     setCalendar(defaultCalendar);
            //     const calendarEntries = await Calendars.ListCalendarEntries(defaultCalendar.id);
            //     setEvents(calendarEntries.map(entry => ({
            //         id: entry.resource.id,
            //         title: entry.resource.eventName,
            //         start: new Date(entry.resource.startDate),
            //         end: new Date(entry.resource.endDate),
            //         color: entry.resource.color || '#3174ad',
            //         icon: entry.resource.icon ? { prefix: 'fas', iconName: entry.resource.icon } : null,
            //         description: entry.resource.description || '',
            //         linkedFacility: entry.resource.linkedFacility,

            //         linkedPatient: entry.resource.linkedPatient,
            //         linkedClinician: entry.resource.linkedClinician,
            //         properties: entry.resource.properties || {},
            //         whenTriggered: entry.resource.whenTriggered,
            //         accessTypes: entry.accessTypes || [],
            //     })));
            // }
        };
        loadCalendars();
    }, [calendarType]);

    // Load calendar events from API
    React.useEffect(() => {
        const loadEvents = async () => {
            if (calendar && calendar.id) {
                const calendarEvents = await Calendars.ListExternalCalendarEntries(calendar.id);
                /*
                {
                "id": "3ce073ba-f4c2-4c60-4ae3-08dd134694a8",
                "summary": "Appointment",
                "startDateTime": "2024-12-03T09:00:00",
                "endDateTime": "2024-12-03T10:00:00",
                "status": "TENTATIVE",
                "action": {
                    "id": "9f812ecb-6062-47a1-86dd-08dcda54b7f5",
                    "eventName": "Request to reschedule"
                },
                "patient": {
                    "id": 5,
                    "title": "",
                    "firstName": "Clinton",
                    "lastName": "Moss Oswald",
                    "idNumber": "9002015056085",
                    "username": "",
                    "emailAddress": "clinton@rootbranch.co.za",
                    "mobileNumber": "0825779793",
                    "userRoles": [],
                    "userFacilitieRoles": []
                },
                "additionalOptions": [],
                "isDeleted": false
                }*/
                console.log("Calendar Events: ", calendarEvents);
                // const filteredEvents = calendarEvents.filter(event => event.resource.availableCalendars.some(c => c.calendarType.type === calendarType));
                const formattedEvents = calendarEvents.map(event => ({
                    id: event.id,
                    title: event.summary,
                    start: new Date(event.startDateTime),
                    end: new Date(event.endDateTime),
                    status: event.status,
                    action: event.action,
                    patient: event.patient,
                    additionalOptions: event.additionalOptions,
                    isDeleted: event.isDeleted,
                    color: event.additionalOptions.find(opt => opt.option === 'COLOUR') || {
                        option: 'COLOUR',
                        value: '#3174ad'
                    },
                    icon: event.additionalOptions.find(opt => opt.option === 'ICON') || {
                        option: 'ICON',
                        value: ''
                    },
                    description: event.description || '',
                    location: event.location || undefined,
                }));
                setEvents(formattedEvents);
            }
        };
        loadEvents();
    }, [calendarType, calendar]);

    const toggle = () => {
        setModal(!modal);
        if (modal) setEditingEvent(null);
    };

    const openPreModal = (mode) => {
        setPreModalMode(mode);
        setShowPreModal(true);
    };
    const closePreModal = () => setShowPreModal(false);

    const handleSelectSlot = (slotInfo) => {
        setSelectedSlot(slotInfo);
        setEditingEvent(null);
        openPreModal('add');
    };

    const handleSelectEvent = (event) => {
        setEditingEvent(event);
        setSelectedSlot({ start: event.start, end: event.end });
        openPreModal('edit');
    };

    const handleSaveEvent = (eventDetails) => {
        console.log("Saving event: ", {
            calendarId: calendar.id,
            eventName: eventDetails.title,
            status: eventDetails.status,
            summary: eventDetails.title,
            startDateTime: format(eventDetails.start, "yyyy-MM-dd'T'HH:mm:ss"),
            endDateTime: format(eventDetails.end, "yyyy-MM-dd'T'HH:mm:ss"),
            action: eventDetails.action,
            patient: eventDetails.patient,
            additionalOptions: eventDetails.additionalOptions,
            isDeleted: eventDetails.isDeleted,
            color: eventDetails.color,
            icon: eventDetails.icon,
            description: eventDetails.description,
            location: eventDetails.location,
        });

        // const apiCall = editingEvent
        //     ? Calendars.UpdateCalendarEvent(editingEvent.id, {
        //         calendarId: calendar.id,
        //         eventName: eventDetails.title,
        //         summary: eventDetails.title,
        //         startDateTime: eventDetails.start.toISOString(),
        //         endDateTime: eventDetails.end.toISOString(),
        //         status: eventDetails.status,
        //         action: eventDetails.action,
        //         patient: eventDetails.patient,
        //         additionalOptions: eventDetails.additionalOptions,
        //         isDeleted: eventDetails.isDeleted,
        //         color: eventDetails.color,
        //         icon: eventDetails.icon,
        //         description: eventDetails.description,
        //     })
        //     : 
        console.log("API Call: ", {
            id: editingEvent ? editingEvent.id : undefined,
            calendar: calendar,
            eventName: eventDetails.title,
            summary: eventDetails.title,
            startDateTime: format(eventDetails.start, "yyyy-MM-dd'T'HH:mm:ss"),
            endDateTime: format(eventDetails.end, "yyyy-MM-dd'T'HH:mm:ss"),
            status: eventDetails.status,
            action: eventDetails.action,
            patient: eventDetails.patient,
            isDeleted: eventDetails.isDeleted,
            additionalOptions: [
                eventDetails.color ? eventDetails.color :
                    {

                        option: 'COLOUR',
                        value: eventDetails.color ?? '#3174ad'
                    },
                eventDetails.icon ? eventDetails.icon :
                    {
                        option: 'ICON',
                        value: eventDetails.icon ?? ""
                    },
            ],
            description: eventDetails.description,
            location: eventDetails.location ?? undefined,
        });
        const apiCall = Calendars.CreateCalendarEntry({
            id: editingEvent ? editingEvent.id : undefined,
            calendar: calendar,
            eventName: eventDetails.title,
            summary: eventDetails.title,
            startDateTime: format(eventDetails.start, "yyyy-MM-dd'T'HH:mm:ss"),
            endDateTime: format(eventDetails.end, "yyyy-MM-dd'T'HH:mm:ss"),
            status: eventDetails.status,
            action: eventDetails.action,
            patient: eventDetails.patient,
            isDeleted: eventDetails.isDeleted,
            additionalOptions: [
                eventDetails.color ? eventDetails.color :
                    {

                        option: 'COLOUR',
                        value: eventDetails.color ?? '#3174ad'
                    },
                eventDetails.icon ? eventDetails.icon :
                    {
                        option: 'ICON',
                        value: eventDetails.icon ?? ""
                    },
            ],
            description: eventDetails.description,
            location: eventDetails.location ?? undefined,
        });


        apiCall.then(result => {
            if (editingEvent && editingEvent.id) {
                setEvents(events =>
                    events.map(ev =>
                        ev.id === editingEvent.id ? { ...ev, ...eventDetails } : ev
                    )
                );
            }
            else {
                const newEvent = {
                    id: result.id,
                    action: eventDetails.action ? {
                        EventName: eventDetails.action.EventName,
                    } : undefined,
                    title: eventDetails.title,
                    start: eventDetails.start,
                    end: eventDetails.end,
                    status: eventDetails.status,
                    action: eventDetails.action,
                    patient: eventDetails.patient,
                    additionalOptions: eventDetails.additionalOptions,
                    isDeleted: eventDetails.isDeleted,
                    color: eventDetails.color,
                    icon: eventDetails.icon,
                    description: eventDetails.description,
                    location: eventDetails.location,
                };
                setEvents([...events, newEvent]);
            }
            toggle();
        }).catch(err => {
            console.error("Error saving event: ", err);
            let message = 'Error saving event. Please try again.';

            // Try to parse .NET Core validation error
            if (typeof err === 'string') {
                try {
                    const parsed = JSON.parse(err);
                    if (parsed && parsed.errors) {
                        // Collect all validation error messages and make them user-friendly
                        message = Object.entries(parsed.errors)
                            .map(([field, errors]) => {
                                // Translate field names to user-friendly labels
                                let fieldLabel = field;
                                if (field === "EventName") fieldLabel = "Event Title";
                                if (field === "StartDateTime") fieldLabel = "Start Date/Time";
                                if (field === "EndDateTime") fieldLabel = "End Date/Time";
                                return `${fieldLabel}: ${errors.join(', ')}`;
                            })
                            .join('\n');
                    } else if (parsed.title) {
                        message = parsed.title;
                    }
                } catch {
                    message = err;
                }
            } else if (err?.message) {
                message = err.message;
            } else if (err && typeof err === 'object' && err.errors) {
                message = Object.entries(err.errors)
                    .map(([field, errors]) => {
                        let fieldLabel = field;
                        if (field === "EventName") fieldLabel = "Event Title";
                        if (field === "StartDateTime") fieldLabel = "Start Date/Time";
                        if (field === "EndDateTime") fieldLabel = "End Date/Time";
                        return `${fieldLabel}: ${errors.join(', ')}`;
                    })
                    .join('\n');
            } else if (err && typeof err === 'object') {
                message = JSON.stringify(err);
            }

            setErrorModal({
                show: true,
                message
            });
        });
        // if (editingEvent) {
        //     setEvents(events =>
        //         events.map(ev =>
        //             ev.id === editingEvent.id ? { ...ev, ...eventDetails } : ev
        //         )
        //     );
        // } else if (selectedSlot) {
        //     const newEvent = {
        //         id: new Date().getTime(), // simple unique id
        //         ...eventDetails,
        //         start: selectedSlot.start,
        //         end: selectedSlot.end,
        //     };
        //     setEvents([...events, newEvent]);
        // }
        // toggle();
    };

    const handleEventDrop = ({ event, start, end }) => {
        setDraggedEvent(event);
        setDraggedSlot({ start, end });
        openPreModal('drag');
    };

    const handlePreModalSelect = (action, mode) => {
        setShowPreModal(false);

        let _action = action
        console.log("PreModal Action: ", action);
        if (!_action.label)
            switch (mode) {
                case 'create':
                    _action = { EventName: 'CREATE_CALENDAR_EVENT' }
                    break;
                case 'edit':
                    _action = { EventName: 'UPDATE_CALENDAR_EVENT' }
                    break;
                case 'delete':
                    _action = { EventName: 'DELETE_CALENDAR_EVENT' }
                    break;
                default:
                    break;
            }
        else
            _action.EventName = action.label;
        setEditingEvent({ ...editingEvent, action: { ..._action } })

        if (preModalMode === 'drag' && draggedEvent && draggedSlot) {
            // Only update event if user confirms reschedule/propose
            setEvents(events =>
                events.map(ev =>
                    ev.id === draggedEvent.id ? { ...ev, start: draggedSlot.start, end: draggedSlot.end } : ev
                )
            );
            setDraggedEvent(null);
            setDraggedSlot(null);
        } else {
            setModal(true);
        }
        // You can store the action if you want to use it in the event modal
    };

    const CustomToolbar = (toolbar) => {
        // Helper to get week number
        function getWeekNumber(date) {
            const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
            const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
            return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
        }

        // Generate year, month, week options
        const currentYear = toolbar.date.getFullYear();
        const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);
        const months = Array.from({ length: 12 }, (_, i) => i);
        const selectedMonth = toolbar.date.getMonth();
        const selectedYear = toolbar.date.getFullYear();
        const selectedWeek = getWeekNumber(toolbar.date);
        // Weeks in year (ISO weeks)
        const weeksInYear = (y) => {
            const d = new Date(y, 11, 31);
            const week = getWeekNumber(d);
            return week;
        };
        const weekOptions = Array.from({ length: weeksInYear(selectedYear) }, (_, i) => i + 1);

        const goToBack = () => {
            toolbar.onNavigate('PREV');
        };

        const goToNext = () => {
            toolbar.onNavigate('NEXT');
        };

        const goToCurrent = () => {
            toolbar.onNavigate('TODAY');
        };

        const handleYearChange = (e) => {
            const newYear = parseInt(e.target.value, 10);
            const newDate = new Date(toolbar.date);
            newDate.setFullYear(newYear);
            toolbar.onNavigate('DATE', newDate);
        };
        const handleMonthChange = (e) => {
            const newMonth = parseInt(e.target.value, 10);
            const newDate = new Date(toolbar.date);
            newDate.setMonth(newMonth);
            toolbar.onNavigate('DATE', newDate);
        };
        const handleWeekChange = (e) => {
            const newWeek = parseInt(e.target.value, 10);
            const newDate = new Date(toolbar.date);
            // Set to first day of selected week
            const jan1 = new Date(newDate.getFullYear(), 0, 1);
            const dayOfWeek = jan1.getDay();
            const daysOffset = (newWeek - 1) * 7 - dayOfWeek + 1;
            jan1.setDate(jan1.getDate() + daysOffset);
            toolbar.onNavigate('DATE', jan1);
        };

        const label = () => {
            const date = toolbar.date;
            return (
                <span>
                    <b>{format(date, 'MMMM yyyy')}</b>
                </span>
            );
        };

        return (<>
            <div className="rbc-toolbar bg-primary-container p-2 m-0 d-flex justify-content-between align-items-center">
                <div className="d-flex flex-wrap align-items-center justify-content-between text-center flex-grow-1">

                    {/* <span className="rbc-btn-group">
                        <Button onClick={goToBack}>Back</Button>
                        <Button onClick={goToCurrent}>Today</Button>
                        <Button onClick={goToNext}>Next</Button>
                    </span> */}
                    <div className='text-center'>
                        <b>Year</b>
                        <select className="form-control text-dark form-control-sm bg-transparent border-0 w-auto ms-2" value={selectedYear} onChange={handleYearChange}>
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className='f-flex flex-column align-items-center'>
                        <b>Month</b>
                        <select className="form-control text-dark form-control-sm bg-transparent border-0 w-auto ms-2" value={selectedMonth} onChange={handleMonthChange}>
                            {months.map(m => <option key={m} value={m}>{format(new Date(selectedYear, m, 1), 'MMMM')}</option>)}
                        </select>
                    </div>
                    <div>
                        <b>Week</b>
                        <select className="form-control text-dark form-control-sm bg-transparent border-0 w-auto ms-2" value={selectedWeek} onChange={handleWeekChange}>
                            {weekOptions.map(w => <option key={w} value={w}>{w}</option>)}
                        </select>
                    </div>
                    <span className="rbc-btn-group text-center calendar-filter ">
                        <div>
                            <b>View</b>
                        </div>
                        <div className='d-flex align-items-center justify-content-center'>
                            <button className={`btn border-0 rounded rounded ${view === 'month' && 'bg-secondary-container shadow'} `} onClick={() => toolbar.onView('month')}><Calendar2MonthFill /></button>
                            <button className={`btn border-0 rounded rounded ${view === 'week' && 'bg-secondary-container shadow'} `} onClick={() => toolbar.onView('week')}><Calendar2WeekFill /></button>
                            <button className={`btn border-0 rounded rounded ${view === 'day' && 'bg-secondary-container shadow'} `} onClick={() => toolbar.onView('day')}><Calendar2DayFill /></button>
                        </div>
                    </span>
                </div>

            </div>
            <div className='bg-primary-container p-2'>
                {calendars.length === 1 ? <></> :
                    <select
                        className="form-control form-control-sm border-0 text-dark"
                        value={calendar?.id || ''}
                        onChange={e => setCalendar(calendars.find(a => a.id === e.target.value))}
                    >
                        {calendars.length > 1 && <option value="">Select Calendar</option>}
                        {calendars.length > 1 ? calendars.map(cal => (
                            <option key={cal.id} value={cal.id}>{cal.name}</option>
                        )) : <option value="">No calendars available</option>}
                    </select>
                }
            </div>
        </>
        );
    };
    return (
        <div>
            {/* Show toolbar and prompt to select a calendar when no calendar selected.
               Keep CustomToolbar available so the user can pick a calendar from the dropdown. */}
            {((Array.isArray(calendar) && calendar.length === 0) || !calendar || !calendar.id) ? (
                <>
                    {/* Render the toolbar so the calendar selector is available. Provide a toolbar-like object
                        with an onNavigate wrapper so the toolbar buttons work as expected. */}
                    <div className="mb-2">
                        {CustomToolbar({
                            date,
                            onView: (v) => setView(v),
                            onNavigate: (action, newDate) => {
                                // Mirror the calendar's onNavigate behaviour enough for the toolbar controls
                                if (action === 'DATE' && newDate instanceof Date) {
                                    setDate(newDate);
                                    return;
                                }
                                if (action === 'TODAY') {
                                    setDate(new Date());
                                    return;
                                }
                                const d = new Date(date || new Date());
                                if (action === 'PREV') {
                                    if (view === 'month') d.setMonth(d.getMonth() - 1);
                                    else d.setDate(d.getDate() - 7);
                                    setDate(d);
                                    return;
                                }
                                if (action === 'NEXT') {
                                    if (view === 'month') d.setMonth(d.getMonth() + 1);
                                    else d.setDate(d.getDate() + 7);
                                    setDate(d);
                                    return;
                                }
                            }
                        })}
                    </div>

                    <div className="p-4 text-center text-muted">
                        <h5>Please select a calendar you would like to manage</h5>
                    </div>
                </>
            ) : (
                <>
                    <DnDCalendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        style={{ height: '80vh' }}
                        selectable
                        onSelectSlot={handleSelectSlot}
                        onSelectEvent={handleSelectEvent}
                        view={view}
                        onView={setView}
                        date={date}
                        onNavigate={setDate}
                        components={{
                            toolbar: CustomToolbar,
                            event: EventComponent
                        }}
                        onEventDrop={handleEventDrop}
                        onEventResize={() => { }} // placeholder for resize handling
                        draggableAccessor={() => true}
                        resizable
                        eventPropGetter={eventPropGetter}
                    />
                </>
            )}
            <PreEventModal
                patientId={id}
                isOpen={showPreModal}
                mode={preModalMode}
                onSelect={handlePreModalSelect}
                onCancel={closePreModal}
            />
            <EventModal
                isOpen={modal}
                toggle={toggle}
                onSave={handleSaveEvent}
                selectedSlot={selectedSlot}
                editingEvent={editingEvent}
            />
            <Modal isOpen={errorModal.show} centered>
                <ModalHeader toggle={() => setErrorModal({ show: false, message: '' })}>Error</ModalHeader>
                <ModalBody>
                    <div className="text-center">
                        <p>{errorModal.message}</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setErrorModal({ show: false, message: '' })}>OK</Button>
                </ModalFooter>
            </Modal>

        </div>
    );
}

function PreEventModal({ patientId, isOpen, mode, onSelect, onCancel }) {
    const [options, setOptions] = useState()
    const CALENDAR_TYPE = useRef()

    React.useEffect(() => {
        const load = async () => {
            const Roles = Authentication.getFacilityRoles();
            if (Roles.filter(x => x !== "Patient" && x !== "Client").length === 0) {
                CALENDAR_TYPE.current = "PATIENT_CALENDAR";
            }
            else if (Roles.includes("Admin")) {
                CALENDAR_TYPE.current = patientId ? "ADMIN_PATIENT" : "ADMIN";
            }
            else if (Roles.includes("Clinician")) {
                CALENDAR_TYPE.current = patientId ? "CLINICIAN_PATIENT" : "CLINICIAN";
            } else {
                CALENDAR_TYPE.current = "ADMIN";
            }
            /// CLONE_CALENDAR_EVENT INITIATE_SEQUENCE MOVE_CALENDAR_EVENT UPDATE_CALENDAR_EVENT CREATE_CALENDAR_EVENT
            // Get Calendar Specific Events
            const filterByCalendarType = (await Calendars.ListCalendarEvents())
                .filter(a => a.resource.availableCalendars.some(c => c.calendarType.type === CALENDAR_TYPE.current))
            // Reduce resource.whenTriggered.trigger as a key and values as the reest of the resource and accessTypes
            const groupedEvents = filterByCalendarType.reduce((acc, curr) => {
                const whenTriggered = curr.resource.whenTriggered.trigger;
                if (whenTriggered) {
                    if (!acc[whenTriggered]) {
                        acc[whenTriggered] = [];
                    }
                    acc[whenTriggered].push({
                        id: curr.resource.id,
                        eventName: curr.resource.eventName,
                        accessTypes: curr.accessTypes,
                        properties: curr.resource.properties,
                        whenTriggered: curr.resource.whenTriggered,
                        linkedFacility: curr.resource.linkedFacility,
                    });
                }
                return acc;
            }, {});
            // console.log('groupedEvents', groupedEvents);
            // console.log('ListCalendarTypes', await Calendars.ListCalendarEvents());
            if (mode === 'add') {
                setOptions(Object.keys(groupedEvents).includes('CREATE_CALENDAR_EVENT') ?
                    groupedEvents['CREATE_CALENDAR_EVENT']
                        .map(event => ({
                            id: event.id,
                            label: event.eventName,
                            value: event.id,
                            properties: event.properties,
                            accessTypes: event.accessTypes,
                            whenTriggered: event.whenTriggered,
                            linkedFacility: event.linkedFacility,
                        })) : undefined);
                // options = [
                //     { label: 'Book First Appointment', value: 'book' },
                //     { label: 'Schedule Emergency Booking', value: 'emergency' }
                // ];
            } else if (mode === 'edit') {
                setOptions(Object.keys(groupedEvents).includes('UPDATE_CALENDAR_EVENT') ?
                    groupedEvents['UPDATE_CALENDAR_EVENT']
                        .map(event => ({
                            id: event.id,
                            label: event.eventName,
                            value: event.id,
                            properties: event.properties,
                            accessTypes: event.accessTypes,
                            whenTriggered: event.whenTriggered,
                            linkedFacility: event.linkedFacility,
                        })) : undefined);
            } else if (mode === 'drag') {
                setOptions(Object.keys(groupedEvents).includes('MOVE_CALENDAR_EVENT') ?
                    groupedEvents['MOVE_CALENDAR_EVENT']
                        .map(event => ({
                            id: event.id,
                            label: event.eventName,
                            value: event.id,
                            properties: event.properties,
                            accessTypes: event.accessTypes,
                            whenTriggered: event.whenTriggered,
                            linkedFacility: event.linkedFacility,
                        })) : undefined);
            }
        }
        load();
    }, [mode, patientId]);


    // let options = [];
    // if (mode === 'add') {
    //     options = [
    //         { label: 'Book First Appointment', value: 'book' },
    //         { label: 'Schedule Emergency Booking', value: 'emergency' }
    //     ];
    // } else if (mode === 'edit') {
    //     options = [
    //         { label: 'Update Event Status', value: 'update' },
    //         { label: 'Cancel Event', value: 'cancel' }
    //     ];
    // } else if (mode === 'drag') {
    //     options = [
    //         { label: 'Reschedule', value: 'reschedule' },
    //         { label: 'Propose New Time Slot', value: 'propose' }
    //     ];
    // }
    return (
        <Modal isOpen={isOpen} toggle={onCancel} size="lg">
            <ModalHeader className='bg-primary-container small' toggle={onCancel}></ModalHeader>
            <ModalBody>
                <div className='d-flex flex-column gap-2'>
                    {options && options.map(opt => (
                        <button className='btn bg-primary-container w-full' key={opt.value} block onClick={() => onSelect(opt, mode)}>{opt.label}</button>
                    ))}
                    {
                        mode !== 'add' &&
                        <button className='btn bg-primary-container w-full' key="view-event" block onClick={() => onSelect("view-event")}>View Event</button>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onCancel}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}

function EventModal({ isOpen, toggle, onSave, selectedSlot, editingEvent }) {
    const [title, setTitle] = useState(editingEvent && editingEvent.title ? editingEvent.title : '');
    const [description, setDescription] = useState(editingEvent && editingEvent.description ? editingEvent.description : '');
    const [status, setStatus] = useState(editingEvent && editingEvent.status ? editingEvent.status : '');
    const [color, setColor] = useState(editingEvent && editingEvent.color ? editingEvent.color : { option: 'COLOUR', value: '#2196f3' });
    const [icon, setIcon] = useState(editingEvent && editingEvent.icon ? editingEvent.icon : { option: 'ICON', value: '' });
    const [additionalNotes, setAdditionalNotes] = useState(editingEvent && editingEvent.additionalNotes ? editingEvent.additionalNotes : '');
    const [calendar, setCalendar] = useState(editingEvent && editingEvent.calendar ? editingEvent.calendar : '');
    const [activeTab, setActiveTab] = useState('1');
    const [startDate, setStartDate] = useState(selectedSlot?.start || new Date());
    const [endDate, setEndDate] = useState(selectedSlot?.end || new Date());
    const [location, setLocation] = useState(editingEvent && editingEvent.location ? editingEvent.location : undefined);

    React.useEffect(() => {
        setStatus(editingEvent && editingEvent.status ? editingEvent.status : '');
        setTitle(editingEvent && editingEvent.title ? editingEvent.title : '');
        setDescription(editingEvent && editingEvent.description ? editingEvent.description : '');
        setColor(editingEvent && editingEvent.color ? editingEvent.color : { option: 'COLOUR', value: '#2196f3' });
        setIcon(editingEvent && editingEvent.icon ? editingEvent.icon : { option: 'ICON', value: '' });
        setAdditionalNotes(editingEvent && editingEvent.additionalNotes ? editingEvent.additionalNotes : '');
        setCalendar(editingEvent && editingEvent.calendar ? editingEvent.calendar : '');
        setStartDate(selectedSlot?.start || new Date());
        setEndDate(selectedSlot?.end || new Date());
        setLocation(editingEvent && editingEvent.location ? editingEvent.location : undefined);
    }, [editingEvent, isOpen, selectedSlot]);

    const handleSave = () => {
        onSave({
            action: editingEvent.action ? { ...editingEvent.action } : undefined,
            title,
            description,
            status,
            color,
            icon,
            additionalNotes,
            calendar,
            start: startDate,
            end: endDate,
            location
        });
        setTitle('');
        setDescription('');
        setColor('#2196f3');
        setIcon(null);
        setAdditionalNotes('');
        setCalendar('');
        setStartDate(new Date());
        setEndDate(new Date());
        setLocation(null);
    };

    const headerText = selectedSlot ? format(selectedSlot.start, 'yyyy/MM/dd HH:mm') : '';

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader className='bg-primary-container' toggle={toggle}>{headerText}</ModalHeader>
            <ModalBody className='p-0'>
                <Row>
                    <Col md={12} className='p-0'>
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={`${activeTab === '1' && 'bg-primary-primary-container'}`} active={activeTab === '1'} onClick={() => setActiveTab('1')}>Event</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink active={activeTab === '2'} onClick={() => setActiveTab('2')}>Customize</NavLink>
                            </NavItem>
                            <ClaimsFilter resources={[{ resource: "Calendars", type: 'Admin' }]} >
                                <NavItem>
                                    <NavLink active={activeTab === '3'} onClick={() => setActiveTab('3')}>Related Data</NavLink>
                                </NavItem>
                            </ClaimsFilter>
                            <NavItem>
                                <NavLink active={activeTab === '4'} onClick={() => setActiveTab('4')}>Synchronize Calendars</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab} className="p-1">
                            <TabPane tabId="1">
                                <Form>
                                    <FormGroup>
                                        <Label for="eventTitle">Event Title</Label>
                                        <Input className='form-control form-control-sm' type="text" name="title" id="eventTitle" value={title} onChange={e => setTitle(e.target.value)} />
                                    </FormGroup>
                                    <div className='d-flex justify-content-between'>
                                        <FormGroup>
                                            <Label>Start Date/Time</Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={date => setStartDate(date)}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                dateFormat="yyyy/MM/dd HH:mm"
                                                className="form-control form-control-sm"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>End Date/Time</Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={date => setEndDate(date)}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                dateFormat="yyyy/MM/dd HH:mm" className="form-control form-control-sm"
                                            />
                                        </FormGroup>
                                    </div>
                                    <FormGroup>
                                        <Label for="location">Location</Label>
                                        {/* <Input className='form-control form-control-sm' type="text" name="location" id="location" /> */}
                                        <FacilitySearchComponent defaultValue={location} setLocation={setLocation} name="location" />
                                    </FormGroup>
                                    {/* <FormGroup>
                                        <Label for="clinician">Clinician</Label>
                                        <Input className='form-control form-control-sm' type="select" name="clinician" id="clinician">
                                            <option>Clinician 1</option>
                                            <option>Clinician 2</option>
                                        </Input>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="patient">Patient</Label>
                                        <Input className='form-control form-control-sm' type="select" name="patient" id="patient">
                                            <option>Patient 1</option>
                                            <option>Patient 2</option>
                                        </Input>
                                    </FormGroup> */}
                                    <FormGroup>
                                        <Label for="eventDescription">Event Description</Label>
                                        <Input className='form-control form-control-sm' type="textarea" name="description" id="eventDescription" value={description} onChange={e => setDescription(e.target.value)} />
                                    </FormGroup>
                                    {/* <FormGroup>
                                        <Label for="details">Details</Label>
                                        <Input className='form-control form-control-sm' type="textarea" name="details" id="details" value={description} onChange={e => setDescription(e.target.value)} />
                                    </FormGroup> */}
                                </Form>
                            </TabPane>
                            <TabPane tabId="2">
                                <h5>Event Color</h5>
                                <TwitterPicker color={color.value} onChangeComplete={(newColor) => setColor({ ...color, value: newColor.hex })} />
                                <hr />
                                <h5>Event Icon</h5>
                                <GenericIconPicker onChange={newIcon => setIcon({ ...icon, value: newIcon[0] })} />
                            </TabPane>
                            <ClaimsFilter resources={[{ resource: "Calendars", type: 'Admin' }]} >
                                <TabPane tabId="3">
                                    {editingEvent && editingEvent.id && <WorkFlowDetailsModal CalendarEntryId={editingEvent.id} expanded />}
                                </TabPane>
                            </ClaimsFilter>
                            <TabPane tabId="4">
                                <ExternalCalendarSyncComponent />
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <ClaimsFilter resources={[{ resource: "Calendars", type: 'Edit' }]} >
                    <Button className='bg-primary-container' onClick={handleSave}>Save</Button>{' '}
                </ClaimsFilter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}


const ExternalCalendarSyncComponent = ({ calendarId, onSync }) => {
    const [availableCalendars, setAvailableCalenders] = useState()

    useEffect(() => {
        // Load calendars or any other initialization logic
        Calendars.ListAvaialbeCelendars().then(calendars => {
            setAvailableCalenders(calendars);
        })
    }, []);

    return availableCalendars && availableCalendars.length > 1 ? <FormGroup className='p-2'>
        <Label for="calendar">Select the calendar you would like to sync this event to</Label>
        <Input type="select" name="calendar" id="calendar"
        //  value={calendar} onChange={e => setCalendar(e.target.value)}
        >
            {availableCalendars.map(cal => (
                <option key={cal.id} value={cal.id}>{cal.name}</option>
            ))}
        </Input>
    </FormGroup> : <p className='text-center p-2'>There are no other calendars available to link this event to</p>

}